/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Maxfeature21Inputs */

const zh_plan_maxfeature21 = /** @type {(inputs: Plan_Maxfeature21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`团队协作`)
};

const en_plan_maxfeature21 = /** @type {(inputs: Plan_Maxfeature21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team collaboration`)
};

const es_plan_maxfeature21 = /** @type {(inputs: Plan_Maxfeature21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colaboración en equipo`)
};

/**
* | output |
* | --- |
* | "Team collaboration" |
*
* @param {Plan_Maxfeature21Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const plan_maxfeature21 = /** @type {((inputs?: Plan_Maxfeature21Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Maxfeature21Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_plan_maxfeature21(inputs)
	if (locale === "en") return en_plan_maxfeature21(inputs)
	return es_plan_maxfeature21(inputs)
});
export { plan_maxfeature21 as "plan_maxFeature2" }